import * as React from 'react';
import { SVGProps } from 'react';

const IconWarningSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.815 2.674a1.378 1.378 0 0 1 2.37 0L23 19c.54.912.064 2-1 2H2c-1.064 0-1.54-1.088-1-2l9.815-16.326zM13.5 18.5c0 .756-.665 1.5-1.5 1.5-1 0-1.514-.825-1.514-1.581s.678-1.368 1.513-1.368c.835 0 1.501.693 1.501 1.449zM12 6c-.76 0-1 .744-1 1.5v6.814c0 .756.24 1.686 1 1.686s1-.93 1-1.686V7.5c0-.756-.24-1.5-1-1.5z"
    />
  </svg>
);
export default IconWarningSizeM;
